/*
 *
 * ProductTour reducer
 *
 */
import produce from 'immer';
import {
  DEFAULT_ACTION,
  UPDATE_DAY_ZERO_STATUS,
  TRIGGER_DAY_ZERO_SHOPIFY_MODAL,
  SHOW_PROFILE_ACTIVATION_SCREEN,
  ENABLE_LOADER,
  DISABLE_LOADER,
} from './constants';

export const initialState = {
  d0ShopifyModal: '',
  d0remindeMe: '',
  shopifyModalStep: null,
  showD0ShopifyModal: false,
  profileActivationScreen: '',
  isLoadingStepScreen: false,
};

/* eslint-disable default-case, no-param-reassign */
const productTourReducer = (state = initialState, action) =>
  produce(state, (/* draft */) => {
    switch (action.type) {
      case ENABLE_LOADER:
        return {
          ...state,
          isLoadingStepScreen: true,
        };
      case DISABLE_LOADER:
        return {
          ...state,
          isLoadingStepScreen: false,
        };
      case TRIGGER_DAY_ZERO_SHOPIFY_MODAL:
        return {
          ...state,
          showD0ShopifyModal: action.payload.modalOpen,
          shopifyModalStep: action.payload.modalOpen ? action.payload.shopifyModalStep:''
        };
      case UPDATE_DAY_ZERO_STATUS:
        return {
          ...state,
          ...action.payload,
        };
      case SHOW_PROFILE_ACTIVATION_SCREEN:
        return {
          ...state,
          profileActivationScreen: action.payload,
        };
      case DEFAULT_ACTION:
        break;
    }
  });

export default productTourReducer;
